( function () {
	'use strict';

	function rubricIndicator () {
		return {
			'templateUrl'      : '/templates/components/indicators/rubric/rubric.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'Rubric',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'flag'        : '@',
				'model'       : '=',
				'viewMode'    : '=',
				'readOnly'    : '=',
				'groupIndex'  : '=',
				'index'       : '=',
				'hideLabel'   : '=',
				'useRange'    : '=',
				'inModal'     : '=',
				'onObs'       : '=',
				'hideScoring' : '=',
				// this is for the formula component
				'groupModel'  : '=',

				'disableDescription' : '='
			}
		};
	}

	function runRubricIndicator ( indicatorService ) {
		indicatorService.register( '4', {
			'data' : {
				'title'         : 'Rubric',
				'path'          : '/templates/components/indicators/rubric/rubric-init.html',
				'type'          : 4,
				'questionText'  : '<p>Untitled Rubric<p>',
				'answerOptions' : [ {
					'optionText'  : 'Title 1',
					'description' : 'Description 1',
					// default id
					'id'          : '00000000-0000-0000-0000-000000000000'
				}, {
					'optionText'  : 'Title 2',
					'description' : 'Description 2',
					// default id
					'id'          : '00000000-0000-0000-0000-000000000000'
				} ]
			}
		} );
	}

	angular
		.module( 'app.components' )
		.run( runRubricIndicator )
		.directive( 'rubricIndicator', rubricIndicator );

	runRubricIndicator.$inject = [ 'indicatorService' ];
} )( );
